module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAASVJREFUSA3tlL0KwjAUhfuzlC6dfAfBqbOTDoXiJPiYBScpdHFydhJ8Bxe7ubT1HGhKKPe2VdCpgZBwc3K/3JO0jjO32YFfOeBqiZMkOWEt8n1/n+f5Q9OlabqoquqI9bIoip2k86RgG4swruu6PjORpGOc69ShUy82FcIKXNe9NU2zkkAGwHXqqBcJCKp2cUM/ked5G1qnxb+CSCCc/ICTZ6YCA9YAjA9WYjbaJ0fshR7QoikA5pgEoRCvbYnhih6gExTjNd0xjjb14u2drIQWIWYArCRj3NZp81GIbRUtQqKYo/bqJNAgpA/gHdAijp+A1DuRAPaXP7ZuV6RWwl/F0DMl0K6o/bXYubu5CoGiRL8MPVOCwjDcUgf7nl3WeTI78DcH3jQfyt92YBMTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./styles/images/close.png
// module id = 840
// module chunks = 1